import React, { Component, ErrorInfo, ReactNode } from 'react';
import { WarningCircle, ArrowClockwise } from '@phosphor-icons/react';
import { Container } from './styles';
import Button from '../Button';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Container>
          <div className="error-card">
            <WarningCircle size={56} weight="duotone" className="error-icon" />
            <h1>Algo deu errado</h1>
            <p>Ocorreu um erro inesperado. Tente recarregar a página.</p>
            <div className="error-actions">
              <Button
                variant="ghost"
                size="sm"
                icon={<ArrowClockwise size={16} />}
                onClick={() => window.location.reload()}
              >
                Recarregar página
              </Button>
            </div>
          </div>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
